import React, { createContext, useContext } from 'react';
import { notification } from '../components';

const NotificationContext = createContext(null);

export const useNotificationContext = () => useContext(NotificationContext);

export const NotificationProvider = ({ children }) => {
    const [api, contextHolder] = notification.useNotification();

    const notifySuccess = ({ message, description, onClose = () => {}, duration = 3 }) => {
        api.success({
            title: message,
            description,
            onClose,
            duration,
        });
    };

    const notifyError = ({ message, description, onClose = () => {}, duration = 5 }) => {
        api.error({
            title: message,
            description,
            onClose,
            duration,
        });
    };

    const notifyInfo = ({ message, description, onClose = () => {}, duration = 3 }) => {
        api.info({
            title: message,
            description,
            onClose,
            duration,
        });
    };

    const notifyWarning = ({ message, description, onClose = () => {}, duration = 4 }) => {
        api.warning({
            title: message,
            description,
            onClose,
            duration,
        });
    };

    return (
        <NotificationContext.Provider
            value={{
                notification: api,
                notifySuccess,
                notifyError,
                notifyInfo,
                notifyWarning,
            }}
        >
            {contextHolder}
            {children}
        </NotificationContext.Provider>
    );
};
